
import { Strategy } from "@/types/strategy-types";
import { toast } from "@/components/ui/use-toast";
import { storeFollowedStrategy } from "@/utils/strategyUtils";
import { supabase } from "@/integrations/supabase/client";
import { NavigateFunction } from "react-router-dom";

interface UseManualPaymentProps {
  strategy?: Strategy;
  isYearly?: boolean;
  transformStrategy: (strategy?: Strategy) => any;
  setIsProcessing: (value: boolean) => void;
  setPaymentError: (error: string | null) => void;
  navigate: NavigateFunction;
}

export const useManualPayment = ({
  strategy,
  isYearly,
  transformStrategy,
  setIsProcessing,
  setPaymentError,
  navigate
}: UseManualPaymentProps) => {
  const handleManualPayment = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsProcessing(true);
    setPaymentError(null);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Store followed strategy after successful payment simulation
      if (strategy) {
        const currentUser = await supabase.auth.getUser();
        const userId = currentUser.data.user?.id;
        
        if (userId) {
          console.log("Storing followed strategy after successful manual payment");
          const transformedStrategy = transformStrategy(strategy);
          
          if (transformedStrategy) {
            await storeFollowedStrategy({
              strategy: transformedStrategy,
              userId,
              originalStrategyId: strategy.id
            });
          }
        }
      }
      
      toast({
        title: "Payment successful! 🎉",
        description: "Welcome to Metrade Premium! You can now follow premium strategies.",
        duration: 5000
      });

      setTimeout(() => {
        navigate('/thank-you', {
          state: {
            strategy,
            isYearly
          }
        });
      }, 500);
    } catch (error) {
      toast({
        title: "Payment failed",
        description: "Please try again or contact support.",
        variant: "destructive"
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return { handleManualPayment };
};
